import coreTheme from 'gatsby-theme-core/src/layout/theme';

const GRAY = '#3a4354';

const theme = process.env.GATSBY_THEME;

export default {
  ...coreTheme,
  // fontSize: '16px',
  // baseLineHeight: '150%',
  sectionSpacer: '3rem',
  fontFamily: 'Open Sans',
  fontWeight: '400',
  fontColor: GRAY,

  // backgroundColor: 'white',
  primaryColor: '#4baa6a',

  grayColor: GRAY,
  grayLightColor: '#c3c9d5',
  grayDarkColor: '#2c323e',

  gray01: '#f3f4f7',
  gray02: '#e7e9ee',
  gray04: '#8793ab',

  vehicle: {
    withSectionWhatsapp: false,
  },

  pagebuilder: {
    backgroundGrey: '#f5f5f5',
  },

  // VersteegBuurman uses this
  ...(theme ? {
    primaryColor: '#C72900',
  } : {}),
};
